(() => {
  // — Fake Variant Dropdown Logic —
  document.querySelectorAll('[data-dropdown]').forEach((dropdown) => {
    const trigger = dropdown.querySelector('[data-dropdown-trigger]');
    const menu = dropdown.querySelector('[data-dropdown-menu]');

    if (!trigger || !menu) return;

    let isHovering = false;
    const mobileDrawerId = trigger.getAttribute('data-mobile-drawer-id');

    // Function to update aria-controls based on screen size
    function updateAriaControls() {
      if (window.matchMedia('(max-width: 699px)').matches) {
        // Mobile: add aria-controls for drawer
        if (mobileDrawerId) {
          trigger.setAttribute('aria-controls', mobileDrawerId);
        }
      } else {
        // Desktop: remove aria-controls to prevent drawer activation
        trigger.removeAttribute('aria-controls');
      }
    }

    // Set initial aria-controls state
    updateAriaControls();

    // Update aria-controls on resize
    window.addEventListener('resize', updateAriaControls);

    // Toggle dropdown (desktop/tablet). On mobile, let navigation-drawer handle via aria-controls.
    trigger.addEventListener('click', (e) => {
      if (window.matchMedia('(max-width: 699px)').matches) {
        // On mobile, let the navigation-drawer handle opening via aria-controls
        return;
      }
      e.preventDefault();
      const isOpen = trigger.getAttribute('aria-expanded') === 'true';

      if (isOpen) {
        closeDropdown();
      } else {
        openDropdown();
      }
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', (e) => {
      if (!dropdown.contains(e.target)) {
        closeDropdown();
      }
    });

    // Handle keyboard navigation from trigger
    trigger.addEventListener('keydown', (e) => {
      if (trigger.getAttribute('aria-expanded') === 'true') {
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          const firstItem = menu.querySelector('.fake-variant-dropdown-item');
          if (firstItem) {
            firstItem.focus();
          }
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          const items = menu.querySelectorAll('.fake-variant-dropdown-item');
          const lastItem = items[items.length - 1];
          if (lastItem) {
            lastItem.focus();
          }
        }
      } else if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        openDropdown();
        setTimeout(() => {
          const items = menu.querySelectorAll('.fake-variant-dropdown-item');
          const targetItem =
            e.key === 'ArrowDown' ? items[0] : items[items.length - 1];
          if (targetItem) {
            targetItem.focus();
          }
        }, 100);
      }
    });

    // Close dropdown on escape key
    document.addEventListener('keydown', (e) => {
      if (
        e.key === 'Escape' &&
        trigger.getAttribute('aria-expanded') === 'true'
      ) {
        closeDropdown();
        trigger.focus();
      }
    });

    // Handle keyboard navigation in dropdown
    menu.addEventListener('keydown', (e) => {
      const items = menu.querySelectorAll('.fake-variant-dropdown-item');
      const currentIndex = Array.from(items).findIndex(
        (item) => item === document.activeElement
      );

      switch (e.key) {
        case 'ArrowDown':
          e.preventDefault();
          const nextIndex =
            currentIndex < items.length - 1 ? currentIndex + 1 : 0;
          items[nextIndex].focus();
          break;
        case 'ArrowUp':
          e.preventDefault();
          const prevIndex =
            currentIndex > 0 ? currentIndex - 1 : items.length - 1;
          items[prevIndex].focus();
          break;
        case 'Enter':
        case ' ':
          e.preventDefault();
          if (
            document.activeElement.classList.contains(
              'fake-variant-dropdown-item'
            )
          ) {
            document.activeElement.click();
          }
          break;
      }
    });

    function openDropdown() {
      trigger.setAttribute('aria-expanded', 'true');
      menu.classList.add('is-open');
      // Don't auto-focus first item - only focus when keyboard navigation starts
    }

    function closeDropdown() {
      trigger.setAttribute('aria-expanded', 'false');
      menu.classList.remove('is-open');
      isHovering = false;
    }

    // Handle hover states to override selected state
    menu.addEventListener('mouseenter', () => {
      isHovering = true;
    });

    menu.addEventListener('mouseleave', () => {
      isHovering = false;
    });

    // Add hover listeners to each dropdown item
    const items = menu.querySelectorAll('.fake-variant-dropdown-item');
    items.forEach((item) => {
      item.addEventListener('mouseenter', () => {
        if (isHovering) {
          // Remove focus from any currently focused item
          items.forEach((otherItem) => {
            if (otherItem !== item) {
              otherItem.blur();
            }
          });
        }
      });
    });
  });

  // — Quantity‐sync logic (keeps both selectors in sync) —
  document.querySelectorAll('product-quick-add').forEach((quickAdd) => {
    const qtyInputs = quickAdd.querySelectorAll(
      '.quantity-selector__input[name="quantity"]'
    );
    if (qtyInputs.length < 2) return;

    qtyInputs.forEach((input) => {
      input.addEventListener('change', () => {
        qtyInputs.forEach((mirror) => {
          if (mirror !== input) mirror.value = input.value;
        });
      });
    });

    quickAdd.querySelectorAll('button[type="submit"]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const visible = Array.from(qtyInputs)
          .reverse()
          .find((el) => el.offsetParent !== null);
        if (visible)
          qtyInputs.forEach((mirror) => (mirror.value = visible.value));
      });
    });
  });

  // — Fix: ensure the correct quantity is sent with the sticky quick-add form —
  document.addEventListener('submit', (evt) => {
    const form = evt.target;
    if (!form.matches('form.product-form')) return;
    const quickAdd = form.closest('product-quick-add');
    if (!quickAdd) return;

    const qtyInput = Array.from(
      quickAdd.querySelectorAll('.quantity-selector__input[name="quantity"]')
    ).find((el) => el.offsetParent !== null);
    if (!qtyInput) return;

    let hiddenQty = form.querySelector('input[name="quantity"]');
    if (!hiddenQty) {
      hiddenQty = document.createElement('input');
      hiddenQty.type = 'hidden';
      hiddenQty.name = 'quantity';
      form.appendChild(hiddenQty);
    }
    hiddenQty.value = qtyInput.value;
  });

  // — Global quantity synchronization for main form and sticky bars —
  const allQtyInputs = document.querySelectorAll('input[name="quantity"]');
  if (allQtyInputs.length > 1) {
    allQtyInputs.forEach((input) => {
      input.addEventListener('change', () => {
        allQtyInputs.forEach((mirror) => {
          if (mirror !== input) mirror.value = input.value;
        });
      });
    });
  }
})();
